module.exports = [{"code":1,"name":"人脸用户"},{"code":2,"name":"IC卡用户"},{"code":3,"name":"人脸+IC卡用户"}]


//////////////////
// WEBPACK FOOTER
// ./static/json/dictionary/passType.json
// module id = LycA
// module chunks = 11